import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { INSPECTIONS_LIST_PERMISSION, INSPECTIONS_PATH } from '&/features/inspections/paths';
import { requireModule } from '&/lib/module-gate';

export const Route = createFileRoute('/_authenticated/inspections')({
  beforeLoad: ({ context }): void => {
    // Entitlement: a tenant without the Inspections module (per the registry) gets the standard
    // not-found. Covers client-side navigation only; the page wraps itself in <ModuleGate> for the
    // hard-refresh case.
    requireModule(context.entitlement, INSPECTIONS_PATH);
    // Permission gate (separate concern): a viewer without `inspections:list` goes back to the Dashboard.
    if (context.permissions.isReady && !context.permissions.hasPermission(INSPECTIONS_LIST_PERMISSION)) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/inspections/pages/inspections-page')),
  staticData: { titleKey: 'inspections' },
});
